import React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { RootState } from "../../store/index.store";
import { dialogPropsSelector } from "../../store/ui.store";
import { DialogProps, DialogType } from "../../types/types";
import { ChangeHistoryDialog } from "./ChangeHistoryDialog/ChangeHistoryDialog";
import { CustomFilterManagementDialog } from "./CustomFilterManagementDialog";
import { CustomFilterRegistrationDialog } from "./CustomFilterRegistrationDialog";
import { JobEditDialog } from "./JobEditDialog/JobEditDialogContainer";
import { LoginDialog } from "./LoginDialog/LoginDialogContainer";

type Dialogs = { [K in DialogType]: ComponentType<any> };

const dialogs: Dialogs = {
  LOGIN: LoginDialog,
  JOB_CREATE: JobEditDialog,
  JOB_UPDATE: JobEditDialog,
  CHANGE_HISTORY: ChangeHistoryDialog,
  CUSTOM_FILTER_REGISTRATION: CustomFilterRegistrationDialog,
  CUSTOM_FILTER_MANAGEMENT: CustomFilterManagementDialog
};

export interface DialogRootProps {
  dialogProps: DialogProps;
}

const Component = (props: DialogRootProps) => {
  const { dialogProps } = props;

  if (!dialogProps.type) {
    return <></>;
  }

  const Dialog = dialogs[dialogProps.type];
  return Dialog ? <Dialog /> : <></>;
};

const mapStateToProps = (state: RootState) => ({
  dialogProps: dialogPropsSelector(state)
});

export const DialogRoot = connect(mapStateToProps)(Component);
